module.exports = __webpack_public_path__ + "img/app_purpose_01.743b8c25.jpg";